import memoize from 'fast-memoize';
import { NavigationOptions } from '@types';

export const filterDisableMenuOption = memoize((menuOption: NavigationOptions, selectedLoanNumber) => {
    let loanNumberMatched;
    if (menuOption?.initParam) {
        loanNumberMatched = menuOption.initParam.find(
            (loanAccount: { loanNumber: string }) => loanAccount.loanNumber === selectedLoanNumber
        );
    }
    return loanNumberMatched?.disable === 'true';
});
